<template>
  <v-content class="education">
    <h5>{{ education.courseName }} at {{ education.schoolName }}</h5>

    <v-subheader class="overline font-weight-light"
      >Relevant Courses</v-subheader
    >
    <p>{{ education.trainingDescription }}</p>
    <v-subheader class="overline font-weight-light"
      >Period and location</v-subheader
    >
    <p class="font-weight-light" v-if="isToday">
      From {{ education.startDate }} to Today in {{ education.address.city + ", " + education.address.country }}
    </p>
    <p v-else>
      From {{ education.startDate }} to {{ education.endDate }} in {{ education.address.city + ", " + education.address.country }}
    </p>

    <v-divider></v-divider>
  </v-content>
</template>

<script>
export default {
  name: "Education",
  props: {
    education: {
      id: Number,
      degree: String,
      courseName: String,
      trainingDescription: String,
      schoolName: String,
      address: {
        city: String,
        country: String,
      },
      startDate: Date,
      endDate: Date,
    },
  },
  computed: {
    isToday() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;
      return this.education.endDate == today ? true : false;
    },
  },
};
</script>
